<template>
	<div class="product-property-list">
    <v-btn small fab class="mb-3" color="primary" @click="showNewItemForm = !showNewItemForm">
			<v-icon>mdi-plus</v-icon>
		</v-btn>
		<template v-if="showNewItemForm">
			<v-form ref="newItemForm" v-model="validItem">
				<v-row no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							v-model="newItemNamePT"
							:label="$gettext('Name') + ' PT'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
						<v-text-field
							v-model="newItemNameEN"
							:label="$gettext('Name') + ' EN'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
						<v-text-field
							v-model="newItemNameES"
							:label="$gettext('Name') + ' ES'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
						<v-select
							v-if="type == 'medicine_interactions'"
							v-model="medicine_interaction_category_id"
							:items="medicineInteractionCategories"
							:label="$gettext('Drug Interaction')"
							item-text="name_pt"
							item-value="id"
							outlined
							class="px-2"
							:rules="[required]"
						></v-select>
					</v-col>
					<v-col v-if="type == 'product_units'" cols="12" sm="6">
						<v-text-field
							v-model="newItemCodePT"
							:label="$gettext('Code') + ' PT'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
						<v-text-field
							v-model="newItemCodeEN"
							:label="$gettext('Code') + ' EN'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
						<v-text-field
							v-model="newItemCodeES"
							:label="$gettext('Code') + ' ES'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
					</v-col>
				</v-row>
			</v-form>
			<v-row no-gutters>
				<v-btn color="primary" class="mb-2" @click="addItem">
					<translate>Add</translate>
				</v-btn>
			</v-row>
		</template>
		<p v-if="items.length == 0" class="font-weight-thin ml-2" v-translate>No items.</p>
		<v-list v-else flat>
			<v-list-item
				v-for="item in items"
				:key="item.id"
				style="border: 1px solid #e0e0e0; border-radius: 5px"
				color="primary"
			>
				<v-list-item-icon class="mr-3">
					<v-icon color="primary">{{itemIcon}}</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>{{item.name_pt}}</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action class="primary--text">
					<v-row no-gutters align="center">
						<v-btn class="ml-3" icon @click="itemEdited = item; showEditItem = true">
							<v-icon color="primary">mdi-pencil</v-icon>
						</v-btn>
						<v-btn v-if="type != 'product_units'" class="ml-1" icon @click="itemToDelete = item; showDeleteItem = true;">
							<v-icon color="primary">mdi-delete</v-icon>
						</v-btn>
					</v-row>
				</v-list-item-action>
			</v-list-item>
		</v-list>
		<v-dialog v-model="showEditItem" max-width="80%">
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Edit</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<v-form ref="editItemForm" v-model="validItem">
						<v-row no-gutters>
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="itemEdited.name_pt"
									:label="$gettext('Name') + ' PT'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
								<v-text-field
									v-model="itemEdited.name_en"
									:label="$gettext('Name') + ' EN'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
								<v-text-field
									v-model="itemEdited.name_es"
									:label="$gettext('Name') + ' ES'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
								<v-select
									v-if="type == 'medicine_interactions'"
									v-model="itemEdited.medicine_interaction_category_id"
									:items="medicineInteractionCategories"
									:label="$gettext('Drug Interaction')"
									item-text="name_pt"
									item-value="id"
									outlined
									class="px-2"
									:rules="[required]"
								></v-select>
							</v-col>
							<v-col v-if="type == 'product_units'" cols="12" sm="6">
								<v-text-field
									v-model="itemEdited.code_pt"
									:label="$gettext('Code') + ' PT'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
								<v-text-field
									v-model="itemEdited.code_en"
									:label="$gettext('Code') + ' EN'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
								<v-text-field
									v-model="itemEdited.code_es"
									:label="$gettext('Code') + ' ES'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showEditItem = false">
						<translate key="close">Close</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="editItem(itemEdited)">
						<translate key="save">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showError" max-width="40%">
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Error</translate>
				</v-card-title>
				<v-card-text class="pt-2">Não foi possível remover o item, este tem produtos a si associados!</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showError = false">
						<translate key="close">Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<DeleteConfirmationDialog v-model="showDeleteItem" :item="type" @delete="deleteItem(itemToDelete)" />
	</div>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";

export default {
	name: "ProductPropertyManager",
	props: ["type", "items", "medicineInteractionCategories"],
	components: {
		DeleteConfirmationDialog
	},
	data: () => ({
		showNewItemForm: false,
		newItemNamePT: "",
		newItemNameEN: "",
		newItemNameES: "",
		newItemCodePT: "",
		newItemCodeEN: "",
		newItemCodeES: "",
		medicine_interaction_category_id: null,
		showEditItem: false,
		showDeleteItem: false,
		validItem: false,
		itemEdited: {},
		itemToDelete: {},
		showError: false
	}),
	computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
    },
    itemIcon() {
			if(this.type == "product_units") return 'mdi-google-circles-communities';
      if(this.type == "substance_types") return 'mdi-spa';
      if(this.type == "plant_parts") return 'mdi-sprout';
			if(this.type == "product_storages") return 'mdi-bottle-tonic-plus';
			if(this.type == "product_presentations") return 'mdi-pill';
			if(this.type == "product_processing") return 'mdi-cached';
      else return 'mdi-pill';
    }
	},
	methods: {
		addItem() {
			if (this.$refs.newItemForm.validate()) {
				const form = new FormData();
				form.append("name_pt", this.newItemNamePT);
				form.append("name_en", this.newItemNameEN);
				form.append("name_es", this.newItemNameES);
				if(this.type == 'product_units') {
					form.append("code_pt", this.newItemCodePT);
					form.append("code_en", this.newItemCodeEN);
					form.append("code_es", this.newItemCodeES);
				}
				if(this.type == 'medicine_interactions') form.append("medicine_interaction_category_id", this.medicine_interaction_category_id);
				axios
					.post("/admin/product_property/" + this.type + "/new", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
							this.items.push(response.data.item);
							this.newItemNamePT = "";
							this.newItemNameEN = "";
							this.newItemNameES = "";
							this.showNewItemForm = false;
						}
					})
					.catch(error => console.log(error));
			}
		},
		editItem(item) {
			if (this.$refs.editItemForm.validate()) {
				const form = new FormData();
				form.append("name_pt", item.name_pt);
				form.append("name_en", item.name_en);
				form.append("name_es", item.name_es);
				if(this.type == 'product_units') {
					form.append("code_pt", item.code_pt);
					form.append("code_en", item.code_en);
					form.append("code_es", item.code_es);
				}
				if(this.type == 'medicine_interactions') form.append("medicine_interaction_category_id", item.medicine_interaction_category_id);
				axios
					.post(
						"/admin/product_property/" + this.type + "/" + item.id + "/edit",
						form
					)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") this.showEditItem = false;
					})
					.catch(error => console.log(error));
			}
		},
		deleteItem(item) {
			axios
				.post(
					"/admin/product_property/" + this.type + "/" + item.id + "/delete"
				)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted"){
						this.items.splice(this.items.indexOf(item), 1);
						this.showDeleteItem = false;
					}
					else {
						this.showDeleteItem = false;
						this.showError = true;
					}
				})
				.catch(error => console.log(error));
		}
	}
};
</script>